import { DecimalPipe } from '@angular/common';
import { Component, computed, DestroyRef, inject, OnInit, Signal, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { AssetClassOverviewFacade, Etf, EtfsByIndices } from '@zero/asset-class-overview/domain';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { IconButtonComponent, TabNavigationComponent } from '@zero/shared/ui-web-design-system';
import { TabNavigationModel } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { filter, tap } from 'rxjs';

@Component({
  selector: 'etfs-by-indices',
  imports: [TranslocoPipe, TabNavigationComponent, DecimalPipe, InstrumentDetailsLinkComponent, IconButtonComponent],
  templateUrl: './etfs-by-indices.component.html',
  styleUrl: './etfs-by-indices.component.scss',
})
export class EtfsByIndicesComponent implements OnInit {
  public readonly facade = inject(AssetClassOverviewFacade);
  public readonly commonRoutes = commonRoutes;
  public readonly tabModel = signal<TabNavigationModel>(undefined);
  public readonly collapsed = signal<boolean>(false);
  public readonly etfs: Signal<Etf[]> = computed(() =>
    this.activeIndex() ? (this.#etfsByIndices()?.find((etfs) => etfs.indexName === this.activeIndex())?.etfs ?? []) : undefined,
  );
  public readonly activeIndex = computed(() => this.tabModel()?.tabs?.find((tab) => tab.active)?.id);

  readonly #destroyRef = inject(DestroyRef);
  readonly #etfsByIndices = signal<EtfsByIndices[]>(undefined);

  ngOnInit(): void {
    this.facade.loadEtfsByIndices();
    this.facade.etfsByIndices$
      .pipe(
        filter((response) => !!response),
        tap((etfsByIndices) => this.#etfsByIndices.set(etfsByIndices)),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe((etfsByIndices) => {
        this.tabModel.set({ tabs: etfsByIndices.map((key, index) => ({ id: key.indexName, active: index === 0 })) });
      });
  }

  public onTabChange = (tabId: string) =>
    this.tabModel.update((model) => ({ tabs: model.tabs.map((tab) => ({ ...tab, active: tab.id === tabId })) }));

  public collapse = () => this.collapsed.update((collapsed) => !collapsed);
}
